import { createContext, useContext } from 'react';
import { type Config, ConfigService, SessionService } from '../core';
import { type ConfigProviderProps } from './types/propTypes';

const ConfigContext = createContext<Config>({});

const ConfigProvider = ({ config, children }: ConfigProviderProps) => {
  ConfigService.setConfigs(config);
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

const useConfig = (): Config => {
  const Config = useContext(ConfigContext);
  const { session } = SessionService.getSession();
  let countryConfigs = { ...Config };
  const resolvedCountry = session.currentCountry;
  if (resolvedCountry) {
    countryConfigs = {
      ...countryConfigs,
      ...(Config[resolvedCountry] as Config),
    };
  }
  return countryConfigs;
};

const useSetConfig = (Config: Config) => {
  ConfigService.setConfigs(Config);
};

export default ConfigProvider;
export { useConfig, useSetConfig };
export type { ConfigProviderProps };
